import { motion } from "framer-motion";
import { useLanguage } from "@/hooks/useLanguage";
import { MapPin, Layers, Cog, MessageCircle } from "lucide-react";
import type { LucideIcon } from "lucide-react";

export default function TrustStripSection() {
  const { t } = useLanguage();

  const cards: { icon: LucideIcon; titleKey: string; descKey: string; color: string }[] = [
    { icon: MapPin, titleKey: "riyadhBased", descKey: "riyadhBasedDesc", color: "from-primary-deep to-secondary-blue" },
    { icon: Layers, titleKey: "multiScope", descKey: "multiScopeDesc", color: "from-secondary-blue to-primary-deep" },
    { icon: Cog, titleKey: "fabrication", descKey: "fabricationDesc", color: "from-primary-deep to-graphite" },
    { icon: MessageCircle, titleKey: "directContact", descKey: "directContactDesc", color: "from-graphite to-secondary-blue" },
  ];

  return (
    <section className="bg-white py-10 md:py-14 px-4 sm:px-6 lg:px-8 border-b border-muted-border">
      <div className="content-container">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          {cards.map((card, i) => {
            const Icon = card.icon;
            return (
              <motion.div
                key={card.titleKey}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: i * 0.1 }}
                className="group relative bg-steel-light rounded-xl p-5 overflow-hidden transition-all duration-300 hover:shadow-card-hover"
              >
                <div className={`absolute top-0 left-0 w-full h-1 bg-gradient-to-r ${card.color} rounded-t-xl`} />
                <Icon className="w-6 h-6 text-primary-deep mb-3 group-hover:scale-110 transition-transform" />
                <h3 className="font-display font-bold text-base text-graphite leading-tight">{t(card.titleKey)}</h3>
                <p className="text-xs text-steel mt-1">{t(card.descKey)}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
